export default __webpack_public_path__ + "static/studio-slider-9-cb2cd5b22de927156d66adc0067b0fe0.png";